/**
 * 날짜 입력칸 ↔ 시각 — **이 브라우저의 하루**로.
 *
 * `<input type="date">` 는 "2026-06-30" 같은 날짜만 준다. 그것을 그대로 서버에 보내면 UTC 자정으로
 * 읽혀, 한국에서는 하루의 경계가 오전 9시가 된다. 캠페인은 종료일 오전 9시에 끝났고, 리포트의
 * "오늘" 은 오전 9시부터였다. 사람이 달력에서 고른 날은 그 사람이 사는 시간대의 하루다.
 *
 * ISO 문자열을 `slice(0, 10)` 해서 날짜를 얻는 것도 같은 실수다 — UTC 날짜가 나온다.
 */

const pad = (value: number): string => String(value).padStart(2, '0');

/** 시각 → 이 브라우저 시간대의 날짜(YYYY-MM-DD). */
export function localDate(value: string | Date): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function parse(value: string): [number, number, number] {
  const [year = 1970, month = 1, day = 1] = value.split('-').map(Number);
  return [year, month - 1, day];
}

/** 날짜 입력 → 그날이 시작하는 시각(ISO). */
export function dayStartIso(value: string): string {
  const [year, month, day] = parse(value);
  return new Date(year, month, day, 0, 0, 0, 0).toISOString();
}

/** 날짜 입력 → 그날이 끝나는 시각(ISO). "30일까지" 는 30일 밤까지다. */
export function dayEndIso(value: string): string {
  const [year, month, day] = parse(value);
  return new Date(year, month, day, 23, 59, 59, 999).toISOString();
}

/** 이 브라우저의 시간대 이름(IANA). 서버가 "하루" 를 같은 기준으로 묶게 넘긴다. */
export function browserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}
